module.exports = __webpack_public_path__ + "img/ryzhkov_vasyl_2.7e122c11.png";